'use client';

import type { PropsWithChildren, ReactNode } from 'react';
import { ChevronLeft } from 'lucide-react';
import { Button, Card } from '@mokoboko/components';

import { PageContainer } from '@/components/page-container';

// One width for the index and the document page, so moving between them does
// not make the card jump.
export const TermsPageShell = ({
  backLabel,
  onBack,
  action,
  children,
}: PropsWithChildren<{
  backLabel: string;
  onBack: () => void;
  action?: ReactNode;
}>) => (
  <PageContainer className="max-w-2xl px-5 pt-5 sm:max-w-2xl sm:px-0 sm:pt-0 md:max-w-2xl">
    <div className="flex flex-col gap-5">
      <div className="on-ground flex items-center justify-between gap-3">
        <Button
          variant="secondary-gray"
          size="lg"
          leadingIcon={<ChevronLeft />}
          onClick={onBack}
        >
          {backLabel}
        </Button>
        {action}
      </div>

      <Card className="!rounded-2xl" contentClassName="flex flex-col gap-5 p-5 sm:p-8">
        {children}
      </Card>
    </div>
  </PageContainer>
);
